let allAnswers = null

const initialState = {
  questionData: null,
  answers: [],
  currentQuestionIndex: -1,
  done: false,
  blockingText: '',
  errorText: '',
  sending: false,
}

const buildAnswerPayload = (questionsData, answersData, userId) => {
  allAnswers = answersData
  const payload = {
    sessionId: questionsData.sessionId,
    donorId: userId,
    healthQuestionnaireId: questionsData.healthQuestionnaireId,
    siteDefinitionCode: questionsData.donationSiteDefinitionCode,
    questions: [],
    donationType: questionsData.donationType,
  }

  const mainQuestionAnswers = allAnswers.filter((a) => !a.parentId)

  processAnswerData(payload, mainQuestionAnswers, true)

  return payload.questions.length > 0 ? payload : null
}

const appendSubQuestionAnswers = (payload, parentId) => {
  const subQuestionAnswers = allAnswers.filter((a) => a.parentId && a.parentId === parentId)

  if (subQuestionAnswers.length === 0) {
    return
  }

  processAnswerData(payload, subQuestionAnswers)
}

const processAnswerData = (payload, answers, isMainQuestion) => {
  const propName = isMainQuestion ? 'questions' : 'subQuestions'
  for (const answerData of answers) {
    const answerPayload = createAnswer(answerData)
    payload[propName].push(answerPayload)
    appendSubQuestionAnswers(answerPayload, answerData.id)
  }
}

const createAnswer = (answerData) => ({
  id: answerData.id,
  answer: {
    answer: answerData.answer,
    comment: `Answered to ${answerData.type}-question nr: ${answerData.questionNumber}\nid[${answerData.id}]`,
  },
  subQuestions: [],
})

export { buildAnswerPayload, initialState }
